import React from 'react';
import { useTranslation } from 'react-i18next';
import { Panel } from '@tanium/react-panel';
import { DefinitionList, DefinitionListItem } from '@tanium/react-definition-list';
import MediumBoldText from 'components/styles/text/MediumBoldText';
import MediumText from 'components/styles/text/MediumText';
import BaseTarget from 'gql/BaseTarget';
import AccessConfiguration from 'components/common/accessInfo/AccessConfiguration';
import TagsDisplay from 'components/common/accessInfo/TagsDisplay';

export interface ITbacDetailsProps {
  baseTarget?: BaseTarget;
  targetAccessLookup: { [key: string]: string };
}
export const TbacDetails = ({ baseTarget, targetAccessLookup }: ITbacDetailsProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Panel title={t('TBAC_INFO')}>
      <DefinitionList>
        <DefinitionListItem
          term={<MediumBoldText>{t('TEAM_ROLE')}:</MediumBoldText>}
          description={<MediumText>{baseTarget?.teamRole || '-'}</MediumText>}
        />
        <DefinitionListItem
          term={<MediumBoldText>{t('ORG_LEADER_ROLE')}:</MediumBoldText>}
          description={<MediumText>{baseTarget?.orgLeaderRole || '-'}</MediumText>}
        />
        <DefinitionListItem
          term={<MediumBoldText>{t('MANAGERS_AD_GROUPS')}:</MediumBoldText>}
          description={<MediumText>{baseTarget?.managersADGroups || '-'}</MediumText>}
        />
        <DefinitionListItem
          term={<MediumBoldText>{t('LIMITED_ACCESS_ROLES')}:</MediumBoldText>}
          description={<MediumText>{baseTarget?.limitedAccessRoles.join(', ') || '-'}</MediumText>}
        />
        <AccessConfiguration
          accessConfigurations={baseTarget?.accessConfiguration}
          individualPanel={false}
          targetAccessLookup={targetAccessLookup}
        />
        <DefinitionListItem
          term={<MediumBoldText>{t('TAGS')}: </MediumBoldText>}
          description={<TagsDisplay tags={baseTarget?.tags} />}
        />
      </DefinitionList>
    </Panel>
  );
};

export default TbacDetails;
